export default "__VITE_PUBLIC_ASSET__668f4f58__"